import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import Tools from './../components/tools';
import Scroll from './../components/scroll';

export default class About {
    constructor() {
        // About

        this.video();
        this.testimonies();
        this.cv();

        Scroll.init();
    }

    video() {
        const btn = document.querySelector('.movie__player [data-id]');
        const btn_alt = document.querySelector('.movie__player [data-type]');
        const iframe = document.querySelector('.movie__popin iframe');
        const video_file = document.querySelector('.movie__popin iframe');
        const closeBtns = document.querySelectorAll('.movie__popinClose');

        if (btn && iframe) {
            btn.addEventListener('click', () => {
                this.displayPopin(iframe, btn.dataset.id, btn);
            });
        }

        if (btn_alt && video_file) {
            btn_alt.addEventListener('click', () => {
                this.displayPopin(video_file, btn_alt.dataset.type, btn_alt);
            });
        }

        if(closeBtns.length > 0) {
            closeBtns.forEach((closeBtn) => {
                closeBtn.addEventListener('click', () => {
                    this.closePopin();
                });
            });
        }
    }

    testimonies() {
        const slider = document.querySelector('.testimony__slider');
        if (slider) {
            tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                nav: false,
                autoHeight: true,
                speed: 650,
                controlsText: ['<span class="sr-only">Précédent</span><svg xmlns="http://www.w3.org/2000/svg" width="10.339" height="10.339" viewBox="0 0 10.339 10.339"><g><path d="M14.556 10.122a.482.482 0 0 1 .678 0l2.371 2.378a.479.479 0 0 1 .015.661l-2.336 2.344a.479.479 0 1 1-.678-.676l1.986-2.016-2.036-2.013a.474.474 0 0 1 0-.678z" transform="translate(-10.512 -7.647)" fill="currentColor"/><path d="M3.375 8.544a5.169 5.169 0 1 0 5.169-5.169 5.169 5.169 0 0 0-5.169 5.169zm.8 0a4.378 4.378 0 1 1 1.282 3.092A4.337 4.337 0 0 1 4.17 8.544z" fill="currentColor" transform="translate(-3.375 -3.375)"/></g></svg>', '<span class="sr-only">Suivant</span><svg xmlns="http://www.w3.org/2000/svg" width="10.339" height="10.339" viewBox="0 0 10.339 10.339"><g><path d="M14.556 10.122a.482.482 0 0 1 .678 0l2.371 2.378a.479.479 0 0 1 .015.661l-2.336 2.344a.479.479 0 1 1-.678-.676l1.986-2.016-2.036-2.013a.474.474 0 0 1 0-.678z" transform="translate(-10.512 -7.647)" fill="currentColor"/><path d="M3.375 8.544a5.169 5.169 0 1 0 5.169-5.169 5.169 5.169 0 0 0-5.169 5.169zm.8 0a4.378 4.378 0 1 1 1.282 3.092A4.337 4.337 0 0 1 4.17 8.544z" fill="currentColor" transform="translate(-3.375 -3.375)"/></g></svg>'],
                responsive: {
                    1024: {
                        autoHeight: false,
                    },
                },
            });
        }
    }

    displayPopin(iframe, src, btn) {
        // iframe.src = `https://player.vimeo.com/video/${src}?autoplay=1&title=0&byline=0&portrait=0`;
        if(src !== 'file') {
            iframe.src = `https://www.youtube.com/embed/${src}`;
        }

        btn.parentElement.nextElementSibling.classList.add('open');
    }

    closePopin() {
        const elt = document.querySelector('.movie__popin.open');
        if(elt) {
            if(elt.querySelector('iframe')) {
                elt.querySelector('iframe').src = '';
            } else {
                elt.querySelector('video').pause();
            }
            elt.classList.remove('open');
        }

    }

    cv() {
        const container = document.querySelector('.cv__container');
        const list = document.querySelector('.cv__list');
        if (container && list) {
            list.style.height = `${list.offsetHeight}px`;
            container.classList.add('js-full');
        }

        this.cvListener(container, list);
    }

    cvListener(container, list) {
        const btn = document.querySelector('.cv__button');
        const initHeight = list.offsetHeight;
        if (btn) {
            btn.addEventListener('click', () => {
                container.classList.toggle('js-open');
                if (container.classList.contains('js-open')) {
                    Tools.fixedToAuto(list, initHeight);
                    btn.querySelector('span').innerText = 'Refermer';
                } else {
                    Tools.autoToFixed(list, initHeight);
                    btn.querySelector('span').innerText = 'Voir plus';
                }
            });
        }
    }
}